import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { YesNoIndicators } from '../../../../../../../global/models/api-model';
import { ArcRoutes } from '../../../../../constants/routes';
import { DocuSignRequest } from '../../../../docusign/models/docusign-models';
import { LayDcPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { PlanAdoptionRoutes } from '../../routes';
import { LayDcPlanAdoptionWizard } from './lay-dc-plan-adoption-wizard';

export class LayDcIndemnifyWizard extends LayDcPlanAdoptionWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();

        return {
            ...content,
            gpsType: GpsType.LayDcAdoptionIndemnify,
            pageTitle: institutionSettings?.adoptLayRSVPIndemnifyTitle,
            PageDescription: '',
            submitLabel: institutionSettings?.adoptLayRSVPIndemnifySubmitLabel,
            cancelLabel: institutionSettings?.adoptLayRSVPIndemnifyCancelLabel,
            indemnifyDocuSignFinishText: institutionSettings?.adoptLayDCIndemnifyDocuSignFinishText,
            indemnifyDocuSignRejectText: institutionSettings?.adoptLayDCIndemnifyDocuSignRejectText,
            indemnifyWarningTitle: institutionSettings?.adoptLayDCIndemnifyWarningTitle,
            indemnifyWarningInstruction1: institutionSettings?.adoptLayDCIndemnifyWarningInstruction1,
            indemnifyWarningInstruction2: institutionSettings?.adoptLayDCIndemnifyWarningInstruction2,
            indemnifyDocuSignTemplateId: institutionSettings?.adoptLayDCIndemnifyDocuSignTemplateId,
            indemnifyDocuSignSubject: institutionSettings?.adoptLayDCIndemnifyDocuSignSubject,
            indemnifySuccessMessage: institutionSettings?.adoptLayDCIndemnifySuccessMessage,            
        };
    }

    getPreviousStepUrl() {
        return `${this.wizardOptions?.institutionRootPath}${ArcRoutes.PlanSummary}`;
    }

    getNextStepUrl() {
        return `${this.wizardOptions?.featureRootPath}${PlanAdoptionRoutes.QccoQuestions}`;
    }

    prepareIndemnificationDocuSignRequest(): DocuSignRequest {

        const defaultRequest = super.prepareIndemnificationDocuSignRequest();
        const initialValues = this.getFormInitialValue();
        const labelSettings = this.epiContent?.labelSettingState?.epiContent;

        const institution = this.wizardOptions?.currentInstitution;
        const institutionAddress = `${institution?.physical_address_1}${institution?.physical_address_2}${institution?.physical_address_3}, ${institution?.physical_city}, ${institution?.physical_state} ${institution?.physical_postal_code}`;

        // TODO: Map the custom text fields.        
        const previousCustomTextTabs = defaultRequest?.tabs?.textTabs || [];

        const customTextTabs = [
            ...previousCustomTextTabs,
            {
                tabLabel: 'complyEpiscopalChurchLayPensionSystem',
                value: initialValues?.complyEpiscopalChurchLayPensionSystem === YesNoIndicators.Yes ? labelSettings?.yesText : labelSettings?.noText,
            },
            {
                tabLabel: 'organization_name',
                value: institution?.organization_name,
            },
            {
                tabLabel: 'organization_address',
                value: institutionAddress,
            },
            {
                tabLabel: 'client_id',
                value: institution?.org_client_nbr,
            },
        ];

        const docuSignRequest: DocuSignRequest = {
            ...defaultRequest,
            tabs: {
                textTabs: customTextTabs,
            },
        };

        return docuSignRequest;
    }
}